/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useState, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Container } from 'app/components';
import { BonusInfoWrapper } from 'app/modules/info/BonusCard/styles';
import { SectionInfoContent, SectionInfo } from 'app/modules/info/styles';
import { SectionTop } from './styles';

const propTypes = {
  content: PropTypes.Array,
  fetchContentLanding: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  resetState: PropTypes.func.isRequired,

  fetchMainUrl: PropTypes.func.isRequired,
  mainUrl: PropTypes.oneOfType([PropTypes.array, PropTypes.any])
};

const Landing = ({ content, fetchContentLanding, match, history: { push }, resetState, fetchMainUrl, mainUrl, }) => {
  const [t, i18n] = useTranslation();
  const [contentData, setContentData] = useState([]);
  const [isAll, setIsAll] = useState('');
  const { slug } = match.params;
  let splitD = slug?.split('-')

  const matchSlug = splitD?.join(' ').toUpperCase();
  const InfoContents = useMemo(
    () => ({
      Content: i18n.language === 'en' || i18n.language === 'en-US' ? 'ContentEN' : 'Content'
    }),
    [i18n.language]
  );

  // useEffect(() => {
  //  fetchMainUrl(slug);
  // }, []);

  const formatString = (inputString) => {
    if (!inputString.includes('-')) {
      const formattedString = inputString.replace(/[-_]/g, ' ').toUpperCase();
      return formattedString;
    }
    else {
      const formattedString = inputString.toLowerCase();
      return formattedString;
    }
  }

  useEffect(() => {
    if (!isNaN(slug)) {
      fetchContentLanding({ id: Number(slug) });
      setIsAll('false');
    }
    else {
      const id = formatString(slug);
      // const id = slug;
      fetchContentLanding({ id: id });
      setIsAll('true');
    }
    resetState();
  }, [slug]);

  useEffect(() => {
    if (content?.length > 0) {
      // eslint-disable-next-line no-unused-vars      
      const dataD = content?.forEach(element => {
        // if (element?.SiteName === matchSlug) {
        if (element?.objectName === matchSlug) {
          setContentData(element);
        }
        // else if (element?.SiteName.toLowerCase().replaceAll(" ", "-") === slug) {
        else if (element?.objectName.toLowerCase().replaceAll(" ", "-") === slug) {
          setContentData(element);
        }

        return null;
      });
    }
  }, [content]);

  useEffect(() => {
    if (content?.length > 0) {
      // eslint-disable-next-line no-unused-vars
      const dataD = content?.forEach(element => {
        // if (element?.SiteName === matchSlug) {
        if (element?.objectName === matchSlug) {
          setContentData(element);
        }
        // else if (element?.SiteName === matchSlug.toLowerCase()) {
        else if (element?.objectName === matchSlug) {
          setContentData(element);
        }
        // else if (element?.SiteName.toLowerCase().replaceAll(" ", "-") === slug) {
        else if (element?.objectName.toLowerCase().replaceAll(" ", "-") === slug) {
          setContentData(element);
        }

        return null;
      });
    }
  }, [isAll === 'true' && content]);

  useEffect(() => {
    if (content?.length > 0) {
      setContentData(content?.[0]);
      //this is included but here site are not showing data CD-674
      //   const splitDD = content?.[0]?.SiteName.toLowerCase();
      //   // const dddd = splitDD.split(' ');
      //   // const matchSlugD = dddd?.join('-');
      //   let url = window.location.href.replace(slug, matchSlugD);
      //   window.location.replace(url);

      // let url = window.location.href.replace(slug, content?.[0]?.SiteName.toLowerCase());
      let url = window.location.href.replace(slug, content?.[0]?.objectName.toLowerCase());
      window.location.replace(url);


      // let url = `/content.node/${matchSlugD}`;
      // push(url);
      // const currentSlug = window.location.pathname.split("/")[window.location.pathname.split("/").length - 1]

      // if (currentSlug !== matchSlugD) {
      // push(generatePath(routes.landing.pattern, { slug: Number(slug) }));
      // push(generatePath(routes.landing.pattern, { slug: matchSlugD }));
      // push(generatePath(routes.landingSlug.pattern, { slug: matchSlugD }));
      // }
    }
  }, [isAll === 'false' && content]);

  const findredirect = mainUrl?.filter(item => {
    if (window.location.href.includes(item?.redirectUrls?.[0]?.redirectUrl)) {
      return item;
    }
  });

  if (mainUrl?.length > 0) {
    if (
      window.location.href.match(mainUrl?.[0]?.redirectUrls?.[0]?.redirectUrl)
    ) {
      if (i18n.language === "en" || i18n.language === 'en-US') {
        sessionStorage.removeItem("movie")
        window.location.replace(findredirect?.[0]?.redirectUrls?.[0]?.mainUrlEN)
      } else {
        sessionStorage.removeItem("movie")
        window.location.replace(findredirect?.[0]?.redirectUrls?.[0]?.mainUrl);
      }
    }
  }

  return (
    <SectionInfo>
      <Container>
        {Object.keys(contentData).length > 1 ? (
          <>
            <BonusInfoWrapper>
              <h1 className="bonus-info__title">{contentData?.SiteName}</h1>
              {/* <h1 className="bonus-info__title">{contentData?.objectName}</h1> */}
            </BonusInfoWrapper>
            <div className="landing-container">
              <div className="cinema-rent__technic-concession-wrapper">
                <div className="cinema-rent__technic-wrapper">
                  <SectionTop>
                    <p dangerouslySetInnerHTML={{ __html: contentData?.[InfoContents.Content] }} />
                  </SectionTop>
                </div>
              </div>
            </div>
          </>
        ) : (
          <SectionInfoContent>
            <h2 style={{ textAlign: 'center' }}>{t('common.coming_soon')}</h2>
          </SectionInfoContent>
        )}

      </Container>
    </SectionInfo>
  );
};

Landing.propTypes = propTypes;
export default Landing;
